import { MapPeekControl } from "../map/MapPeekControl.js";
import { useGame } from "../../app/GameProvider.js";

type Props = { kicker: string; title: string };

export function ChoiceHead({ kicker, title }: Props) {
  const { dispatch } = useGame();

  return (
    <header className="choice-head">
      <div>
        <p className="kicker" style={{ color: "var(--action)", letterSpacing: "0.2em", fontSize: 11 }}>
          {kicker}
        </p>
        <h1>{title}</h1>
      </div>
      <div className="choice-head-actions">
        <button
          type="button"
          className="choice-deck-open"
          onClick={() => dispatch({ type: "OPEN_OVERLAY", overlay: "deck" })}
        >
          デッキ
        </button>
        <MapPeekControl />
      </div>
    </header>
  );
}
